<template>
  <div>
    <div class="container">
      <div class="target-section">
        <div class="target-selector">
          <div class="target-title">
            {{ $t('label.product') }}
          </div>
          <scpm-tree-dropdown
            :disabled="isDisabled"
            class="selector product-type"
            v-model="proCode"
            :items="productTypeGroups"
            @update:modelValue="onChangeProductTypeCode"
            :placeholder="$t('message.selectProductType')"
          />
          <lego-dropdown
            class="selector"
            :disabled="isDisabled"
            v-if="subProductCodes.length"
            v-model="subProCode"
            :items="subProductCodes"
            @update:modelValue="onChangeSubTypeCode"
          />
        </div>
      </div>
      <div class="target-block">
        <div class="target-header">
          <div>
            <div class="target-title">
              {{ title ? title : $t('title.monTarget') }}
              <span v-if="isShowAsterisk" style="color: #d93526">*</span>
            </div>
            <!-- <span class="required-target" v-if="showErrorMessage">
              {{ $t('message.input1', [$t('label.monitoring') + ' ' + $t('label.target')]) }}
            </span> -->
          </div>
          <scpm-drop-down :open="openDropDown">
            <template #anchor>
              <lego-button
                class="add-btn"
                :disabled="!isMatchCurrentProject || isDisabledBtn"
                @click="openDialog"
                primary
                >{{ $t('button.add') }}</lego-button
              >
              <div v-if="listTarget.length" class="text-selected">
                {{ listTarget.length + ' ' + $t('label.selected') }}
              </div>
              <div v-if="listTarget.length" class="clear-items" @click="remove(null)">
                <span>{{ $t('button.allRemove') }}</span>
              </div>
            </template>
            <div class="container-dialog" :style="dropdownStyle">
              <div class="container-dialog__content">
                <slot />
              </div>
              <div class="container-dialog__footer">
                <lego-button @click.stop="onCloseDialog">{{ $t('button.cancel') }}</lego-button>
                <lego-button @click.stop="onConfirmDialog" main>{{
                  $t('button.confirm')
                }}</lego-button>
              </div>
            </div>
          </scpm-drop-down>
        </div>
        <c-scroll style="width: 100%; max-height: 72px">
          <div class="items-section">
            <template v-if="listTarget.length">
              <div class="selected-items">
                <div v-for="(item, idx) in listTarget" :key="idx" class="chip">
                  <c-asg v-if="item.isASG" />
                  <div style="display: flex; align-items: center">
                    <span class="chip-text" v-if="item.isHTML" v-html="item.label"></span>
                    <span class="chip-text" v-else>{{ item.label }}</span>
                    <span v-if="item.objectName && item.objectType" class="listTargetItem"
                      >:
                      {{ item.objectDisplayName || item.objectName }}
                    </span>
                  </div>
                  <span class="chip-close">
                    <lego-icon @click="remove(item)">close</lego-icon>
                  </span>
                </div>
              </div>
            </template>
            <div
              v-else
              :class="`no-item-selected ${!subProductCodes.length ? 'one' : 'two'}-dropdown`"
            >
              {{
                defaultProductCode
                  ? $t('message.pleaseAddTheMonitoringTarget')
                  : $t('message.pleaseSelectProductType')
              }}
            </div>
          </div>
        </c-scroll>
      </div>
    </div>
  </div>
</template>
<script>
import ScpmDropDown from '../../components/scpm/common/ScpmDropDown.vue';

export default {
  name: 'MonitoringTargetCommon',
  emits: [
    'remove',
    'change-product-type-code',
    'change-sub-type-code',
    'open-drop-down',
    'confirm-dialog',
    'close-dialog'
  ],
  components: { ScpmDropDown },
  props: {
    title: {
      type: String
    },
    productTypeGroups: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    productCodes: {
      type: Array,
      default: () => []
    },
    defaultProductCode: {
      type: String,
      default: ''
    },
    subProductCodes: {
      type: Array,
      default: () => []
    },
    defaultSubProductCode: {
      type: String,
      default: ''
    },
    resetTarget: {
      type: Boolean,
      default: false
    },
    showErrorMessageMonitoringTarget: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: () => ''
    },
    requiredAsterisk: {
      type: Boolean,
      default: false
    },
    dropdownStyle: {
      type: Object,
      default: () => ({
        width: '800px',
        height: '640px',
        padding: '24px'
      })
    },
    isDisabledBtn: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.selectedItemsTerm = this.selectedItems;
  },
  data() {
    return {
      openDropDown: false,
      proCode: '',
      subProCode: '',
      selectedItemsTerm: '',
      // isDisabledConfirm: true,
      listTarget: []
    };
  },
  watch: {
    defaultProductCode: {
      handler(v) {
        this.proCode = v;
      },
      immediate: true
    },
    defaultSubProductCode: {
      handler(v) {
        this.subProCode = v;
      },
      immediate: true
    },
    selectedItems: {
      handler(v) {
        if (!this.openDropDown) {
          this.listTarget = v;
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isShowAsterisk() {
      return this.mode == 'addMetric' || this.requiredAsterisk;
    },
    showErrorMessage() {
      return this.showErrorMessageMonitoringTarget && this.mode == 'addMetric';
    },
    isMatchCurrentProject() {
      return this.$store.state.isMatchCurrentProject;
    }
  },
  methods: {
    remove(item) {
      if (!item) {
        this.listTarget = [];
      }
      this.$emit('remove', item);
    },
    onChangeProductTypeCode(productTypeCode) {
      this.$emit('change-product-type-code', productTypeCode);
    },
    onChangeSubTypeCode(subTypeCode) {
      this.$emit('change-sub-type-code', subTypeCode);
    },
    openDialog() {
      this.openDropDown = true;
      this.$emit('open-drop-down');
    },
    onConfirmDialog() {
      this.listTarget = this.selectedItems;
      this.openDropDown = false;
      this.$emit('confirm-dialog');
    },
    onCloseDialog() {
      this.openDropDown = false;
      this.$emit('close-dialog');
    }
  }
};
</script>
<style lang="scss" scoped>
.text-selected {
  margin: 0 16px;
  align-content: center;
  color: #2c59d9;
  font-weight: 700;
}
.badge-asg {
  display: flex;
  align-items: center;
}
.target-block {
  width: 100%;
}
.container-dialog {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  width: 100%;

  &__content {
    border-bottom: 1px solid #e4e5e7;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }

  &__footer {
    display: flex;
    justify-content: end;
  }
}

.container {
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  padding-bottom: 24px;

  .target-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 328px;
    min-width: 328px;
    padding-right: 24px;
  }

  .items-section {
    display: flex;
    gap: 8px;
    width: 100%;
  }
}

.target-header {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-bottom: 8px;

  .target-title {
    color: #2e3138;
    font-family: $lego__font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }

  .required-target {
    color: #fc434e;
    font-size: 12px;
  }

  .clear-items {
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: #737a8c;
    font-family: $lego__font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    height: 32px;

    span {
      border-bottom: 1px solid #737a8c;
      padding-bottom: 3px;
    }
  }

  :deep(.dropdown) {
    .anchor {
      display: flex;
    }
  }
}

.target-selector {
  display: flex;
  gap: 8px;
  width: 100%;
  flex-direction: column;

  .target-title {
    color: #2e3138;
    font-family: $lego__font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    text-transform: capitalize;
    height: 32px;
    display: flex;
    align-items: center;
  }

  .selector {
    width: 100%;
  }
}

.items-section {
  display: flex;
  gap: 8px;

  .no-item-selected {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 72px;
    color: #878e9b;
    font-family: $lego__font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-left: -16px;

    &.one-dropdown {
      height: 32px;
    }

    &.two-dropdown {
      height: 72px;
    }
  }

  .selected-items {
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.clear-items:hover {
  cursor: pointer;
  color: #2e3138;

  span {
    border-color: #2e3138;
  }
}

.chip {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: max-content;
  height: 32px;
  padding: 0px 12px;
  border-radius: var(--radius-pill, 100px);
  background: var(--color-alias-background-action-primary-container-default, #eff1fb);

  .listTargetItem {
    display: inline-block;
    color: #364fc7;
  }

  .chip-close {
    margin-top: 2px;
    font-size: 16px;
    cursor: pointer;
  }
}

:deep .lego-table__area-wrapper {
  border-bottom: unset !important;
}

:deep .lego-table-wrap {
  padding-top: 12px !important;

  .lego-table__top {
    padding-bottom: 12px;
    margin-bottom: unset !important;

    .lego-table__control {
      height: unset;

      .lego-table__counter__total {
        height: unset;
        line-height: unset;
      }
    }
  }
}

:deep .lego-dropdown__title {
  border-radius: 2px;
}

.product-type {
  :deep {
    .lego-dropdown__item:first-of-type,
    .lego-dropdown__item:last-child {
      border-radius: initial !important;
    }
  }
}
</style>
